// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SearchField — toolbar search box with clear button + "/" hint. */
.search {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 240px;
  max-width: 380px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid var(--border);
  background: var(--surface);
  border-radius: var(--radius-1);
  color: var(--text-muted);
}
.search input {
  border: 0;
  background: transparent;
  outline: none;
  flex: 1;
  font-family: var(--sans);
  font-size: var(--fs-ui);
  color: var(--text);
}
.search__clear {
  background: transparent;
  border: 0;
  color: var(--text-muted);
  cursor: pointer;
  display: inline-grid;
  place-items: center;
  padding: 0;
  flex: none;
}
.search__clear:hover {
  color: var(--text);
}
.search svg {
  width: 15px;
  height: 15px;
  stroke-width: 1.5;
}
.search .kbd {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  border: 1px solid var(--border);
  border-radius: 2px;
  padding: 0 4px;
  flex: none;
  height: 18px;
  line-height: 16px;
  display: inline-flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/ui/SearchField/SearchField.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,OAAO;EACP,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB","sourcesContent":["/* SearchField — toolbar search box with clear button + \"/\" hint. */\n.search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 240px;\n  max-width: 380px;\n  height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  border-radius: var(--radius-1);\n  color: var(--text-muted);\n}\n.search input {\n  border: 0;\n  background: transparent;\n  outline: none;\n  flex: 1;\n  font-family: var(--sans);\n  font-size: var(--fs-ui);\n  color: var(--text);\n}\n.search__clear {\n  background: transparent;\n  border: 0;\n  color: var(--text-muted);\n  cursor: pointer;\n  display: inline-grid;\n  place-items: center;\n  padding: 0;\n  flex: none;\n}\n.search__clear:hover {\n  color: var(--text);\n}\n.search svg {\n  width: 15px;\n  height: 15px;\n  stroke-width: 1.5;\n}\n.search .kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  border: 1px solid var(--border);\n  border-radius: 2px;\n  padding: 0 4px;\n  flex: none;\n  height: 18px;\n  line-height: 16px;\n  display: inline-flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
